
import { Options, Vue } from 'vue-class-component';
import { mapGetters } from 'vuex';
import DemoGame from '@/base-components/DemoGame.vue';
import GamePopUp from '@/base-components/GamePopUp.vue';
import config from '@/config.json';

@Options({
  computed: {
    ...mapGetters(['getGames', 'getJsonData']),
    jsonData() {
      const jsonData = (this as any).getJsonData;
      const jsonDataWithBreaks = JSON.stringify(jsonData).replace(/\\n/g, '<br>');
      return JSON.parse(jsonDataWithBreaks);
    },
    slides() {
      return (this as any).getGames;
    },
    showGameDescription() {
      return config.showGameDescription;
    }
  },
  components: { DemoGame, GamePopUp }
})
export default class Games extends Vue {
  msg!: string
}
